var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDashboardIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38271 3.39974L8.18271 5.19974C8.44938 5.46641 8.98271 5.46641 9.24938 5.19974L11.0494 3.39974C11.516 2.93307 11.1827 2.06641 10.516 2.06641H6.91605C6.24938 2.13307 5.91605 2.93307 6.38271 3.39974ZM6.38271 12.5997L8.18271 10.7997C8.44938 10.5331 8.98271 10.5331 9.24938 10.7997L11.0494 12.5997C11.516 13.0664 11.1827 13.9331 10.516 13.9331H6.91605C6.24938 13.8664 5.91605 13.0664 6.38271 12.5997ZM2.18271 7.66641L3.64938 5.33307C3.84938 4.93307 4.38271 4.86641 4.71605 5.19974L7.04938 7.53307C7.31605 7.79974 7.31605 8.19974 7.04938 8.46641L4.71605 10.7997C4.38271 11.1331 3.91605 11.0664 3.64938 10.6664L2.18271 8.33307C1.98271 8.13307 1.98271 7.86641 2.18271 7.66641ZM15.2494 7.66641L13.7827 5.33307C13.5827 4.99974 13.0494 4.93307 12.716 5.19974L10.3827 7.53307C10.116 7.79974 10.116 8.19974 10.3827 8.46641L12.716 10.7997C13.0494 11.1331 13.516 11.0664 13.7827 10.6664L15.2494 8.33307C15.4494 8.13307 15.4494 7.86641 15.2494 7.66641Z",
    stroke: "#D42177",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDashboardIcon3);
export default __webpack_public_path__ + "static/media/projectDashboardIcon3.01961be5226206f2b369f6d4f4258a77.svg";
export { ForwardRef as ReactComponent };